import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Typography } from '@sequelae/lore-core';
import { useNavigationMode } from '../../contexts/NavigationModeContext';
import { NavigationModeToggle } from '../../components/NavigationModeToggle';
import { NavigationTestButtons } from '../../components/NavigationTestButtons';
import '../../styles/shared-styles.css';
import '../../styles/about.css';

export const About = () => {
  const navigate = useNavigate();
  const { isNativeMode } = useNavigationMode();

  useEffect(() => {
    console.log('[MenuMFE] About page mounted');
  }, []);

  const menuItems = [
    {
      id: 'privacy',
      title: 'Privacy Policy',
      url: 'https://www.lore.co/privacypolicy',
      path: '/about/privacy',
    },
    {
      id: 'terms',
      title: 'Terms of Use',
      url: 'https://www.lore.co/terms',
      path: '/about/terms',
    },
  ];

  const handleNativePush = (path: string) => {
    console.log(`🚀 CommunicationBridge.openMFEModule: MenuMFE → ${path}`);
    // CommunicationBridge handles all fallbacks internally (postMessage, routing, etc.)
    CommunicationBridge.openMFEModule({
      url: 'https://menu-mfe-nonprod.lorehealthcare.io',
      scope: 'MenuMFE',
      module: 'MenuMFE',
      path: path,
    });
  };

  const handleMenuItemClick = (item: { id: string; title: string; url: string; path: string }) => {
    if (isNativeMode) {
      // Use CommunicationBridge.openMFEModule to open Terms/Privacy in new webview
      handleNativePush(item.path);
    } else {
      // Use React Router navigation in legacy web-like mode
      navigate(item.path);
    }
  };

  return (
    <div className="screen">
      <div className="shared-container">
        <div className="menu-container android">
          <header className="menu-header">
            {!isNativeMode && (
              <Button className="back-button" onClick={() => navigate(-1)} variant="text">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z"
                    fill="#1C1B1F"
                  />
                </svg>
              </Button>
            )}
            <Typography variant="h1" className="menu-header-title">
              About
            </Typography>
            <NavigationModeToggle />
          </header>

          <div className="about-content">
            <div className="about-menu">
              {menuItems.map((item, index) => (
                <div key={index} className="about-menu-item">
                  <button className="menu-link-button" onClick={() => handleMenuItemClick(item)}>
                    <Typography variant="body" className="menu-title">
                      {item.title}
                    </Typography>
                    <div className="menu-arrow">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <polygon points="10,6 16,12 10,18" fill="currentColor" />
                      </svg>
                    </div>
                  </button>
                </div>
              ))}
            </div>
            <div className="navigation-test-spacer">
              <NavigationTestButtons />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
